import { Injectable } from '@angular/core';
import { SaveHandlers, UnitOfWorkBase } from 'app/core/services';
import { UserService } from 'app/core/user/user.service';
import { Entity } from 'breeze-client';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseEntity } from '../base-entity';
import { TimeBaseEntity } from '../time-base-entity';

@Injectable()
export class ModelSaveHandlers extends SaveHandlers {
  constructor(private readonly userService: UserService) {
    super();
  }

  beforeSaveEntity(
    unitOfWork: UnitOfWorkBase,
    entity: Entity
  ): Observable<boolean> {
    if (entity instanceof BaseEntity) {
      return this.beforeSaveBaseEntity(entity);
    } else if (entity instanceof TimeBaseEntity) {
      return this.beforeSaveTimeBaseEntity(entity);
    }

    return of(true);
  }

  private beforeSaveBaseEntity(entity: BaseEntity): Observable<boolean> {
// Set audit columns
      return this.userService.user$.pipe(
        map((user) => {
          const now = new Date();

          if (entity.entityAspect.entityState.isAdded()) {
            // entity.ts = core.getUuid();
            entity.createdBy = user.name;
            entity.createdDate = now;
            entity.updatedBy = user.name;
            entity.updatedDate = now;
          }

          if (entity.entityAspect.entityState.isModified()) {
            entity.updatedBy = user.name;
            entity.updatedDate = now;
          }

          return true;
        })
      );
  }

  private beforeSaveTimeBaseEntity(entity: TimeBaseEntity): Observable<boolean> {
          // Set audit columns
      return this.userService.user$.pipe(
        map((user) => {
          const now = new Date();

          if (entity.entityAspect.entityState.isAdded()) {
            entity.createdBy = user.name;
            entity.createdAt = now;
            entity.updatedBy = user.name;
            entity.updatedAt = now;
          }

          if (entity.entityAspect.entityState.isModified()) {
            entity.updatedBy = user.name;
            entity.updatedAt = now;
          }

          return true;
        })
      );
  }
}
